export const getGoogle = () => {
  return (window as any).google;
};
